import React, {useContext, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from "moment";

import DatePicker from "../../../controls/DatePicker";
import FuelRateDuplicateDialogValidator from "../validators/FuelRateDuplicateDialogValidator";
import SystemContext from "../../../SystemContext";
import { useTheme } from '@material-ui/core';

const FuelRateDuplicateDialog = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const dateFormat = "DD/MM/YYYY";
  const minDate = moment().subtract(3,'months').toISOString();
  let fromDate = moment();
  let toDate = moment().add(1,'week');

  if (moment(props.validFrom).isSame(moment(props.validFrom).startOf('month')) && moment(props.validTo).isSame(moment(props.validFrom).endOf('month').startOf('day'))) {
    fromDate = moment(props.validFrom).add(1, 'month');
    toDate = moment(props.validFrom).add(1, 'month').endOf("month");
  }

  if (moment(props.validFrom).diff(moment(props.validTo), 'days') === -6) {
    fromDate = moment(props.validFrom).add(7, 'days');
    toDate = moment(props.validTo).add(7, 'days');
  }

  if (moment(props.validFrom).diff(moment(props.validTo), 'days') === -13) {
    fromDate = moment(props.validFrom).add(14, 'days');
    toDate = moment(props.validTo).add(14, 'days');
  }

  const [record, setRecord] = useState({
    open: props.open,
    uuids: props.uuids,
    validFrom: fromDate.format('YYYY-MM-DD'),
    validTo: toDate.format('YYYY-MM-DD'),
  });

  if (props.uuids !== record.uuids || props.open !== record.open) {
    setRecord({
      open: props.open,
      uuids: props.uuids,
      validFrom: fromDate.format('YYYY-MM-DD'),
      validTo: toDate.format('YYYY-MM-DD'),
      });
  }

  const [validationState, setValidationStatus] = useState({
    error: true,
    errorMessage: "checking",
    field: null
  });

  const handleClose = () => {
    if (props.onChange)
      props.onChange({state: 'cancel'});
  };
  
  const handleSave = () => {
    saveDuplicateRate();
    // if (props.onChange)
    //   props.onChange({state: 'save', record});
  };
  
  async function saveDuplicateRate (){
    if (validationState.error) {
      SystemData.openAlert("Error", validationState.errorMessage);
      if (validationState.field) {
        const field = document.getElementById(validationState.field);
        if (field) {
          field.focus();
        }
      }
    } else {
      props.onChange({state: 'save', record: {...record}});
    }
  }

  if (props.open){
    return (
      <div id={"DuplicateFuelRateDialog"}>
        <Dialog open={props.open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                disableBackdropClick={true}
        >
          <DialogTitle id="form-dialog-title">
            <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
              Duplicate a Fuel Rate
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please enter the validity period for the duplicated rate.
            </DialogContentText>
            <div>
              <DatePicker
                id="validFrom"
                label="Valid From"
                minDate={minDate}
                value={record.validFrom}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
                onChange={(value)=> {
                  setRecord({...record, validFrom: moment(value).format('YYYY-MM-DD')})
                }}
              />
            </div>
            <div style={{ marginTop:5}} >
              <DatePicker
                id="validTo"
                label="Valid To"
                minDate={record.validFrom}
                value={record.validTo}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
                onChange={(value)=> {
                  setRecord({...record, validTo: moment(value).format('YYYY-MM-DD')})
                }}
              />
            </div>
            <FuelRateDuplicateDialogValidator
              record={record}
              onChange={(validation) => {
                setTimeout(()=> {
                  setValidationStatus(validation);
                },1);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default FuelRateDuplicateDialog;